export { default } from './SearchCard';
